Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconSearchData: "data:image/svg+xml,%3csvg width='19' height='19' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M8 2a6 6 0 110 12A6 6 0 018 2zm0-2a8 8 0 100 16A8 8 0 008 0z' fill='currentColor' fill-rule='nonzero'/%3e%3cpath d='M13 13l5 5' stroke='currentColor' stroke-width='2' stroke-linecap='round'/%3e%3c/g%3e%3c/svg%3e",
  iconSearchWidth: 19,
  iconSearchHeight: 19
};